import {Directive, HostListener, Input} from '@angular/core';


@Directive({
  selector: '[highlightOnOver]',
  standalone: true
})
export class HighlightDirective {

  @Input() highlightOnOver: string;

  @HostListener('mouseover') onMouseOver(): void {
    const element = document.querySelector(`${this.highlightOnOver}`);
    if (element) {
      element.classList.add('highlighted-element');
    }
  }

  @HostListener('mouseout') onMouseOut(): void {
    const element = document.querySelector(`${this.highlightOnOver}`);
    if (element) {
      element.classList.remove('highlighted-element');
    }
  }
}
